import { render } from "./CompareHeadline.vue?vue&type=template&id=93fbf672"
import script from "./CompareHeadline.vue?vue&type=script&lang=js"
export * from "./CompareHeadline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__